(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ib-slider"] && !Shopify.designMode) return;
  try {
    
const swiper = new Swiper('.testimonial-cf', {
  effect: 'coverflow',
  grabCursor: true,
  centeredSlides: true,
  loop: true,
  slidesPerView: "auto",
  centeredSlides: true,
  initialSlide: 2,
  slidesPerView: 5,
  coverflowEffect: {
    // rotate: 0,
    // stretch: 0,
    // depth: 230,
    // modifier: 2.2,
    // scale: 0.85,
    // slideShadows: true,
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 3,
    initialSlide: 3,
    slideShadows: true
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    0: { slidesPerView: 1.2 },
    768: { slidesPerView: 2 },
    1200: { slidesPerView: 3 }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
